import { Button } from '@eventbrite/eds-button';
import { Icon } from '@eventbrite/eds-icon';
import { ChevronDownChunky as ChevronDownChunkySvg } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { AnimatedDrawer } from '../AnimatedDrawer';
import FilterPanel from './FilterPanel';
import './FilterPanelMobile.scss';

interface FilterPanelMobileProps {
    openCloseAnimatedDrawer?: Function;
    onFilterChange?: Function;
    filterTypeToShow?: $FixMe;
}

const DoneButton = ({ openCloseAnimatedDrawer }: FilterPanelMobileProps) => (
    <Button
        size="block"
        style="fill"
        onClick={() => openCloseAnimatedDrawer?.(false)}
        data-testid="filter-panel-mobile--done-btn"
    >
        {gettext('Done')}
    </Button>
);

export const FilterPanelMobile = (props: FilterPanelMobileProps) => {
    const applyFilter = (
        key?: number,
        val?: string,
        shouldUpdateRoute?: boolean,
    ) => {
        //If filter is being applied, val !== all. In that case we
        //want to render the general filters view
        if (val !== 'all') {
            props.openCloseAnimatedDrawer?.(true, '', false);
        }

        props.onFilterChange?.(key, val, shouldUpdateRoute);
    };

    return (
        <AnimatedDrawer>
            <FilterPanel
                {...props}
                isMobile={true}
                renderPanelHeaderAction={() => (
                    <span className="filter-title--mobile__panel-close-btn">
                        <Button
                            style="none"
                            onClick={() =>
                                props.openCloseAnimatedDrawer?.(false)
                            }
                            title="Close filter panel"
                            data-testid="filter-title__panel-close-btn"
                        >
                            <Icon
                                type={<ChevronDownChunkySvg />}
                                size="medium"
                                color="grey-800"
                            />
                        </Button>
                    </span>
                )}
                stickyFooter={
                    !props.filterTypeToShow && (
                        <DoneButton
                            openCloseAnimatedDrawer={
                                props.openCloseAnimatedDrawer
                            }
                        />
                    )
                }
                onFilterChange={(...args: any) => applyFilter(...args)}
                handleDrawerSelect={(val: string) =>
                    props.openCloseAnimatedDrawer?.(true, val, false)
                }
            />
        </AnimatedDrawer>
    );
};
export default FilterPanelMobile;
